import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {
  shwchat =true;
  constructor() { }

  ngOnInit() {
  }

  shoswchatwindow(){
     this.shwchat=!this.shwchat;
  }
}



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.component.ts